// @flow

import PageContainer from 'insight/pages/common/PageContainer';
import ManagerDataGrid from 'insight/components/datagrid/manager/ManagerDataGrid';
import { APPLICATION_PAGE } from 'insight/constants/GlobalConstants';
import PageTitle from '../../../common/components/PageTitle';

const ManagerSubscriptions = (): React$Node => {
  return (
    <PageContainer>
      <PageTitle titleKey={'app.page.title.manager.subscriptions'} />
      <ManagerDataGrid dataGridPage={APPLICATION_PAGE.MANAGER_SUBSCRIPTIONS} />
    </PageContainer>
  );
};

export default ManagerSubscriptions;
